import { render, staticRenderFns } from "./dataGridOptions.vue?vue&type=template&id=4e2d64fc"
import script from "./dataGridOptions.ts?vue&type=script&lang=js&external"
export * from "./dataGridOptions.ts?vue&type=script&lang=js&external"
import style0 from "./dataGridOptions.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports